import React, { useEffect, useState } from "react";
import { translationConstants } from "../../../../../constants";
import { useTranslation } from "react-i18next";
import UpcomingEventsCard from "./UpcomingEventsCard";
import { useDispatch, useSelector } from "react-redux";
import { DashboardActions } from "../../../../../redux/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import {loadingIndicator, dataEndMessage} from "../../../../../shared/utilitiies"

const defaultQueryExpression = "id != null ";
//-------initial gridstate
const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: defaultQueryExpression,
};

const UpcomingEventsSideView = () => {
  const { t } = useTranslation();
  const [gridState, setGridState] = useState(initialGridState);
  const dispatch = useDispatch();

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );

  useEffect(() => {
    dispatch(
      DashboardActions.getUserRecommendationsData(systemUserId, gridState)
    );
    // eslint-disable-next-line
  }, [gridState]);
  
  const userRecommendationsData = useSelector(
    (state) => state.dashboardReducer.userRecommendationsData
  );


  //-------Get More Centers List on Scroll
  const getMoreCenterDetails = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  return (
    <div className="mx-md-4 mx-2 my-4 p-md-3 p-2 dashboard-right-sidebar">
      <h6 className="top-heading">
        {t(translationConstants.UPCOMING_EVENTS_COMPETITIONS)}
      </h6>
      <div className="d-flex flex-column gap-2">
        {userRecommendationsData.data && (
          <InfiniteScroll
            dataLength={userRecommendationsData.data?.length ?? 0}
            next={getMoreCenterDetails}
            hasMore={
              userRecommendationsData.data?.length % 7 === 0 &&
              userRecommendationsData.data?.length !== 0
                ? true
                : false
            }
            loader={loadingIndicator(t)}
            endMessage={""}
            style={{ overflow: "hidden" }}
            scrollableTarget={"main-container"}
          >
            <div className="row m-0 w-100">
              {userRecommendationsData.data?.map((eventData) => {
                return <UpcomingEventsCard eventData={eventData} />;
              })}
            </div>
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

export default UpcomingEventsSideView;
